import React from 'react';

const Sidebar = () => {
  const menuItems = [
    {
      label: 'Profile',
      icon: 'https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/e4ede81877b09bbd7583d0669b29e28df566f2a8?placeholderIfAbsent=true',
      active: false
    },
    {
      label: 'Orders',
      icon: 'https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/5c5a6514334a877f3213c2031be33519a50c89f6?placeholderIfAbsent=true',
      active: true
    },
    // { label: 'Purchases', active: false },
    { label: 'Subscription Plan', active: false },
    { label: 'My Address', active: false },
    { label: 'Settings', active: false },
    { label: 'Share App', active: false },
    { label: 'Log out', active: false }
  ];

  return (
    <aside className="text-sm text-white max-md:mt-9">
      <div className="pt-4 rounded-xl bg-sky-950">
        <img
          src="https://api.builder.io/api/v1/image/assets/2a838274f46548a0b8b8310254100157/d9f7ac47a8b051b7421c6ffa6e379583a91a8441?placeholderIfAbsent=true"
          alt="Profile banner"
          className="object-contain mx-3 rounded-none aspect-[3.8] w-[278px] max-md:mx-2.5"
        />
        <nav className="flex flex-col items-center mt-4 w-full">
          {menuItems.map((item, index) => (
            <div
              key={index}
              className={`flex gap-10 justify-between items-center px-5 py-4 w-full border-b border-white border-opacity-10 max-w-[302px] ${
                item.active ? 'bg-white bg-opacity-10' : ''
              } ${index === menuItems.length - 1 ? 'border-b-0' : ''}`}
            >
              <div className="flex gap-3.5 items-center self-stretch my-auto">
                {item.icon && (
                  <img
                    src={item.icon}
                    alt=""
                    className="object-contain shrink-0 self-stretch my-auto w-5 aspect-[0.95] fill-green-500"
                    aria-hidden="true"
                  />
                )}
                <span className="self-stretch my-auto">{item.label}</span>
              </div>
              <div className="flex shrink-0 self-stretch my-auto h-[18px] w-[18px]" aria-hidden="true" />
            </div>
          ))}
        </nav>
      </div>
    </aside>
  );
};

export default Sidebar;
